import { StyleSheet } from "@react-pdf/renderer";

export default StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    marginVertical: 10
  },
  snoContainer: {
    width: 30,
  },
  snoText: {
    fontSize: "12pt",
  },
  questionText: {
    fontSize: "12pt",
    flex: 1,
  },
  answerText: {
    fontSize: "12pt",
    fontWeight: "black"
  },
});
